module.exports = __webpack_public_path__ + "static/media/plus-clarnium.e30337c7.svg";